import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ImageIcon from "../../Assets/images/VoxApp-Icon.png";
import ModernEmailIcon from "../../Assets/svgs/ModernEmailIcon";
import ModernGreenCheckIcon from "../../Assets/svgs/ModernGreenCheckIcon";
import { dateFormat } from "../../Common/DateAndTimeFormat";
import { Loader } from "../../Common/Loader";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { deleteScheduledEmail } from "../../Redux/Slice/Contacts/Email/DeleteScheduledEmailSlice";
import { getScheduledEmails } from "../../Redux/Slice/Contacts/Email/GetScheduledEmailsSlice";
import EditIcon from "../../Assets/svgs/EditIcon";
import TrashIcon from "../../Assets/svgs/TrashIcon";

export const Emails = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedtab, setSelectedTab] = useState(1);
  const [emailList, setEmailList] = useState([]);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState();
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const tabs = [
    { key: 1, filter: "upcoming" },
    { key: 2, filter: "scheduled" },
    { key: 3, filter: "completed" },
  ];
  const changeTab = (value) => {
    setSelectedTab(value);
    getEmails(value);
  };
  useEffect(() => {
    getEmails(1);
  }, []);

  const getEmails = async (tab) => {
    const filterVal = tabs.find((x) => x.key === tab).filter;
    let contactId = location.pathname.split("/")[2];
    const result = await dispatch(
      getScheduledEmails({
        filter: filterVal,
        contactId: props?.isForContactGroup ? "" : contactId,
        contactGroupId: props?.isForContactGroup ? contactId : "",
      })
    );
    setEmailList(result?.payload?.data);
  };

  const dateTimeFormat = (dateString, timeString) => {
    // Parse the ISO date
    const date = new Date(dateString);
    // Split the time string into hours, minutes, and seconds
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    // Set the time on the date object in UTC
    date.setHours(hours, minutes, seconds);
    // Define options for formatting
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    // Format the date without a comma
    const formattedDate = dateFormat(dateString);

    // Format the time (12-hour format with AM/PM)
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    // Combine and return the final output
    return `${formattedDate} ${formattedTime}`;
  };

  const deleteEmail = async () => {
    setCOnfirmModel(false);
    const result = await dispatch(deleteScheduledEmail(selectedEmail.id));

    if (
      deleteScheduledEmail.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessMessage("Email Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        navigate(-1);
      }, 1500);
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  return (
    <div className="CreateScheduleCall__row">
      {isLoading ? <Loader /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {confirmModel ? (
        <ConfirmModel
          onAccept={deleteEmail}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Delete Email!"
          message="Are you sure you want to Delete the email?"
        />
      ) : (
        ""
      )}
      <div className="CreateScheduleCall__row__col">
        <div className="CreateScheduleCall__card">
          <div className="CreateScheduleCall__card__head">All Emails</div>
          <div className="CreateScheduleCall__card__body p_0">
            <div className="tabsWrap">
              <ul className="tabs">
                <li
                  className={
                    selectedtab === 1
                      ? "tabs__link tabs__link--selected"
                      : "tabs__link"
                  }
                  onClick={() => changeTab(1)}
                >
                  Upcoming Emails
                </li>
                <li
                  className={
                    selectedtab === 2
                      ? "tabs__link tabs__link--selected"
                      : "tabs__link"
                  }
                  onClick={() => changeTab(2)}
                >
                  Scheduled Emails
                </li>
                <li
                  className={
                    selectedtab === 3
                      ? "tabs__link tabs__link--selected"
                      : "tabs__link"
                  }
                  onClick={() => changeTab(3)}
                >
                  Completed Emails
                </li>
              </ul>
            </div>
            <div className="tabsContent">
              <div className="tabsContent__content tabsContent__content--selected">
                <div className="scheduledCallList">
                  {emailList && emailList.length > 0 ? (
                    emailList.map((email) => (
                      <div className="scheduledCallList__item">
                        <div className="scheduledCallList__card">
                          <div className="scheduledCallList__card__head">
                            <div className="profile">
                              <div className="icon">
                                <ModernEmailIcon
                                  width={22}
                                  height={17}
                                  color="#8b58f1"
                                />
                              </div>
                              <div className="info">
                                <h4 className="name">{email?.subject}</h4>
                                <p className="para">
                                  {dateTimeFormat(
                                    email?.date,
                                    email?.emailTime
                                  )}
                                </p>
                              </div>
                            </div>
                            {selectedtab == 3 ? (
                              <div className="btn__group">
                                <div className="status status--complete">
                                  <ModernGreenCheckIcon />
                                  Completed
                                </div>
                              </div>
                            ) : (
                              <div className="btn__group">
                                <button
                                  className="btn"
                                  onClick={() => props.onEdit(email)}
                                >
                                  <EditIcon />
                                </button>
                                <button
                                  className="btn"
                                  onClick={() => {
                                    setSelectedEmail(email);
                                    setCOnfirmModel(true);
                                  }}
                                >
                                  <TrashIcon />
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="scheduledCallList__card__body">
                            <h5 className="title">Sent From</h5>
                            <div className="participant">
                              <div className="participant__item">
                                <div className="participant__profile">
                                  <div className="initials">
                                    <img
                                      src={
                                        email?.assistant?.avatar || ImageIcon
                                      }
                                      alt=""
                                    />
                                  </div>
                                  <div className="info">
                                    <h4 className="name">
                                      {email?.assistant
                                        ? email?.assistant?.name
                                        : ""}
                                    </h4>
                                    <p className="para">Assistant</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="scheduledCallList__card__body">
                            <h5 className="title">Sent To</h5>
                            <div className="participant">
                              <div className="participant__item">
                                <div className="participant__profile">
                                  <div className="initials">
                                    <img
                                      src={email?.contact?.avatar || ImageIcon}
                                      alt=""
                                    />
                                  </div>
                                  <div className="info">
                                    <h4 className="name">
                                      {email?.contact?.firstName
                                        ? email?.contact?.firstName +
                                          " " +
                                          email?.contact?.lastName
                                        : email?.externalContact?.firstName
                                        ? email?.externalContact?.firstName +
                                          " " +
                                          email?.externalContact?.lastName
                                        : email?.contact?.name}
                                    </h4>
                                    <p className="para">Contact</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "center",
                      }}
                    >
                      No Emails{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
